<template>
  <section id="settlement">
    <div class="head" style="height: 52px;background-color:#fff;margin-bottom: 60px;"></div>
    <div class="box">
      <div class="content">
        <!--配送信息-->
        <div class="address">
          <p class="title">配送信息</p>
          <div class="details" v-if="addressList.length">
            <!--地址列表-->
            <ul class="oul">
              <li class="ite" :class="active === index ? 'selected' : ''" v-for="(item, index) in addressList" :key="index" @click="choose(index, item)">
                <div class="top mt2">
                  <span>{{item.receiveName}}</span>
                  <span style="margin-left: 15px;">{{item.receivePhone}}</span>
                </div>
                <p class="adr mt1">{{item.province}}{{item.city}}{{item.area}}{{item.address}}</p>
                <i class="iconfont icon-delete left" @click="prompt = true"></i>
                <div class="prompt" v-if="prompt">
                  <div class="word">
                    <div class="tet">确定删除此地址信息吗</div>
                    <div class="flex">
                      <p class="cancel" @click="prompt = false">取消</p>
                      <p class="ensure" @click="revise(index)">确定</p>
                    </div>
                  </div>
                </div>
                <i class="el-icon-edit-outline right" @click="changeAaddress(item)"></i>
              </li>
              <div class="ite change" @click="compute(1)" v-show="addressList.length < 4">
                <i class="el-icon-circle-plus-outline"></i>
                <span>添加新地址</span>
              </div>
            </ul>
          </div>
          <div class="details" v-else>
            <form action="">
              <input type="text"
                     v-model="name"
                     maxlength="7"
                     placeholder="请输入姓名">
              <input type="text"
                     maxlength="11"
                     v-model="iphone" placeholder="请输入电话"
                     class="ml"
                     onkeyup="this.value=this.value.replace(/[^0-9-]+/,'');">
              <div class="select" style="margin-top: 20px;">
                <el-select v-model="province" placeholder="请选择省份" @change="changeProvince(province, 2)">
                  <el-option
                      v-for="item in options"
                      :key="item.areaId"
                      :label="item.areaName"
                      :value="item.areaName">
                  </el-option>
                </el-select>

                <el-select v-model="city" collapse-tags style="margin-left: 20px;"
                           placeholder="请选择城市" @change="changeProvince(city, 3)">
                  <el-option
                      v-for="item in optionsCity"
                      :key="item.areaId"
                      :label="item.areaName"
                      :value="item.areaName">
                  </el-option>
                </el-select>
                <el-select
                    v-model="area"
                    collapse-tags
                    style="margin-left: 20px;"
                    placeholder="请选择区">
                  <el-option
                      v-for="item in optionsArea"
                      :key="item.areaId"
                      :label="item.areaName"
                      :value="item.areaName">
                  </el-option>
                </el-select>
              </div>
              <input type="text" v-model="address" style="width: 476px;margin-top: 20px;" placeholder="详细地址">
              <div class="btn">
                <input type="reset" value="取消" class="cancel">
                <button class="submit ml" @click="preserve">保存</button>
              </div>
            </form>
          </div>
          <div class="new" v-if="addAddress">
            <p class="title" style="border-bottom: none;padding-bottom: 0;">新增地址</p>
            <div class="details">
              <form action="">
                <input type="text"
                       v-model="name"
                       maxlength="7"
                       placeholder="请输入姓名">
                <input type="text"
                       maxlength="11"
                       v-model="iphone" placeholder="请输入电话"
                       class="ml"
                       onkeyup="this.value=this.value.replace(/[^0-9-]+/,'');">
                <div class="select" style="margin-top: 20px;">
                  <el-select v-model="province" placeholder="请选择省份" @change="changeProvince(province, 2)">
                    <el-option
                        v-for="item in options"
                        :key="item.areaId"
                        :label="item.areaName"
                        :value="item.areaName">
                    </el-option>
                  </el-select>

                  <el-select v-model="city" collapse-tags style="margin-left: 20px;"
                             placeholder="请选择城市" @change="changeProvince(city, 3)">
                    <el-option
                        v-for="item in optionsCity"
                        :key="item.areaId"
                        :label="item.areaName"
                        :value="item.areaName">
                    </el-option>
                  </el-select>
                  <el-select
                      v-model="area"
                      collapse-tags
                      style="margin-left: 20px;"
                      placeholder="请选择区">
                    <el-option
                        v-for="item in optionsArea"
                        :key="item.areaId"
                        :label="item.areaName"
                        :value="item.areaName">
                    </el-option>
                  </el-select>
                </div>
                <input type="text" v-model="address" style="width: 476px;margin-top: 20px;" placeholder="详细地址">
                <div class="btn">
                  <input type="reset" value="取消" class="cancel">
                  <button class="submit ml" @click="preserve">保存</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!--支付方式-->
        <div class="pay_way mt3">
          <p class="title">支付方式</p>
          <div class="details">
            <button class="pay">在线支付</button>
          </div>
        </div>
        <!--商品清单-->
        <div class="goods mt3">
          <p class="title">商品清单</p>
          <div class="details" style="padding-top: 0;">
            <div class="item"  v-for="(goods, index) in goodsList" :key="index">
              <img :src="goods.product.productImage" alt="">
              <span style="margin-left: 144px;display: inline-block;width: 260px;">{{goods.product.specifications}}/超高亮/{{goods.product.productName}}</span>
              <span style="margin-left: 98px;">￥{{goods.product.category.productPrice}}</span>
              <span style="margin-left: 248px;">x{{goods.num}}</span>
            </div>
            <!--去付款-->
            <div class="buy">
              <p class="text">应付：<span class="rmb">￥<span class="number">{{allPirce | shareNowPrice}}</span></span></p>
                <button @click="goPay">去付款</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" style="height: 60px;"></div>
  </section>
</template>

<script>
import {removeItem} from '../../common/js/localSg.js'
export default {
  name: 'settlement',
  data () {
    return {
      active: parseInt(localStorage.getItem('digital')) || 0,
      prompt: false,
      addAddress: false,
      addressId: null,
      name: '',
      iphone: '',
      address: '',
      province: '',
      city: '',
      area: '',
      options: [{
        'areaId': '110000',
        'areaName': '北京市',
        'areaLevel': 1
      }, {
        'areaId': '120000',
        'areaName': '天津市',
        'areaLevel': 1
      }, {
        'areaId': '130000',
        'areaName': '河北省',
        'areaLevel': 1
      }],
      optionsCity: [{
        'areaId': '440100',
        'areaName': '广州市',
        'areaLevel': 2
      }, {
        'areaId': '440200',
        'areaName': '韶关市',
        'areaLevel': 2
      }, {
        'areaId': '440300',
        'areaName': '深圳市',
        'areaLevel': 2
      }, {
        'areaId': '440400',
        'areaName': '珠海市',
        'areaLevel': 2
      }, {
        'areaId': '440500',
        'areaName': '汕头市',
        'areaLevel': 2
      }],
      optionsArea: [{
        'areaId': '440103',
        'areaName': '荔湾区',
        'areaLevel': 3
      }, {
        'areaId': '440106',
        'areaName': '天河区',
        'areaLevel': 3
      }, {
        'areaId': '440111',
        'areaName': '白云区',
        'areaLevel': 3
      }],
      addressList: [],
      goodsList: {},
      cartIdList: [],
      order: {}
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.path !== '/shoppingCar/settlement') {
      localStorage.removeItem('goods')
    }
    next()
  },
  computed: {
    // 总价
    allPirce () {
      var res = 0
      for (var i = 0; i < this.goodsList.length; i++) {
        var pic = this.goodsList[i].product.category.productPrice * this.goodsList[i].num
        res += pic
      }
      return res
    }
  },
  mounted: function (s) {
    if (!this.$root.getUserId()) {
      this.$store.commit('setToastMsg', '请登录')
      this.$router.push('/login')
      return
    }
    this.changeProvince('', 1)
    this.getGoodsList()
    this.getAddressList()
  },
  methods: {
    // 省市区
    changeProvince (e, areaLevel) {
      let that = this
      that.axios.post('../api/sys/area/getSel', {
        areaLevel: areaLevel,
        parentId: e
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          var res = response.data.value
          if (areaLevel === 1) {
            that.options = res
            that.optionsCity = []
            that.optionsArea = []
            that.city = ''
            that.area = ''
          } else if (areaLevel === 2) {
            that.optionsCity = res
            that.optionsArea = []
            that.city = ''
            that.area = ''
          } else if (areaLevel === 3) {
            that.optionsArea = res
            that.area = ''
          }
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    // 获取地址列表
    getAddressList () {
      let that = this
      that.axios.post('/address/list', {
        userId: that.$root.getUserId()
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          that.addressList = response.data.value
          console.log(6060)
          console.log(that.addressList)
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    choose (d, address) {
      this.active = d
      localStorage.setItem('digital', d)
      localStorage.setItem('addressId', address.addressId)
    },
    // 修改地址
    changeAaddress (address) {
      let that = this
      that.name = address.receiveName
      that.iphone = address.receivePhone
      that.province = address.province
      that.city = address.city
      that.area = address.area
      that.address = address.address
      that.compute(2)
    },
    // 删除地址
    revise (i) {
      let that = this
      that.axios.post('/address/del', {
        addressId: that.addressList[i].addressId
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          that.addressList.splice(i, 1)
          that.prompt = false
          localStorage.removeItem('digital')
          that.$store.commit('setToastMsg', '删除成功')
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    // 购买的产品列表
    getGoodsList () {
      let that = this
      setTimeout(function () {
        let goods = JSON.parse(localStorage.getItem('goods'))
        that.goodsList = goods
      }, 200)
    },
    compute (num) {
      let that = this
      if (num === 1) {
        that.name = ''
        that.iphone = ''
        that.province = ''
        that.city = ''
        that.area = ''
        that.address = ''
      } else if (num === 2) {
        that.addressId = localStorage.getItem('addressId')
      }
      that.addAddress = true
    },
    // 提交地址
    preserve () {
      let that = this
      if (!that.name) {
        that.$store.commit('setToastMsg', '请填写您的姓名')
        return
      }
      if (!that.iphone) {
        that.$store.commit('setToastMsg', '请填写您手机号码')
        return
      }
      if (!(that.province && that.city && that.address)) {
        that.$store.commit('setToastMsg', '请填写完整的地址信息')
        return
      }
      that.axios.post('/address/save', {
        userId: that.$root.getUserId(),
        addressId: that.addressId,
        receiveName: that.name,
        receivePhone: that.iphone,
        province: that.province,
        city: that.city,
        area: that.area,
        address: that.address
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          that.$store.commit('setToastMsg', response.data.msg)
          that.getAddressList()
          that.addAddress = false
          that.name = ''
          that.iphone = ''
          that.province = ''
          that.city = ''
          that.area = ''
          that.address = ''
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    // 付款
    goPay () {
      let that = this
      var dList = []
      for (var i = 0; i < that.goodsList.length; i++) {
        var pList = {}
        pList.cartId = that.goodsList[i].cartId
        removeItem(that.goodsList[i].cartId)
        pList.productId = that.goodsList[i].product.productId
        pList.num = that.goodsList[i].num
        pList.installType = that.goodsList[i].installType
        dList.push(pList)
      }
      console.log(dList)
      that.axios.post('/order/save', {
        userId: that.$root.getUserId(),
        addressId: localStorage.getItem('addressId') || that.addressList[0].addressId,
        details: JSON.stringify(dList)
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          that.$router.replace({name: 'payment', params: {codeUrl: response.data.value.codeUrl, orderId: response.data.value.orderId}})
          that.order = response.data.value
          localStorage.removeItem('goods')
          let num = parseInt(localStorage.getItem('c')) - that.goodsList.length
          localStorage.setItem('c', num)
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  }
}
</script>

<style scoped>
  #settlement{
    background-color: #f0f0f0;
    box-sizing: border-box;
  }
  .ml{
    margin-left: 20px;
  }
  .mt3{
    margin-top: 30px;
  }
  .box{
    width: 1201px;
    margin: 0 auto;
  }
  .content{
    text-align: left;
    box-sizing: border-box;
  }
  /*-----------添加地址样式-----------*/
  .content .address,
  .content .pay_way,
  .content .goods{
    background-color: #fff;
  }
  .title{
    text-align: left;
    padding: 39px 40px 19px 40px;
    font-size: 18px;
    font-family: "SourceHanSansCN-Medium";
    color: #333;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e5e5;
  }
  .details{
    padding: 30px 40px;
  }
  .details input{
    width: 226px;
    height: 44px;
    font-size: 16px;
    padding-left: 15px;
    font-family: "SourceHanSansCN-Normal";
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    border-radius: 4px;
  }
  .btn{
    margin-top: 20px;
  }
  .btn>input{
  }
  .btn .cancel{
    width: 199px;
    height: 44px;
    background-color: #f4f4f4;
    border-radius: 3px;
    font-size: 16px;
    color: #000;
    font-family: "SourceHanSansCN-Normal"
  }
  .btn .submit{
    width: 199px;
    height: 44px;
    background-color: #7e7d7d;
    border-radius: 3px;
    font-size: 16px;
    color: #fff;
    font-family: "SourceHanSansCN-Normal"
  }
  /*----------------地址列表样式-----------------*/
  .oul{
    display: flex;
    flex-wrap: wrap;
  }
  .ite{
    width: 260px;
    height: 171px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 20px 15px;
    font-size: 16px;
    color: #333;
    margin-top: 15px;
    margin-left: 15px;
    display: inline-block;
  }
  .ite:hover{
    /*background-color: #f4f4f4;*/
    cursor: pointer;
    border: 1px solid #05b570;
  }
  .selected{
    /*background-color: #f4f4f4;*/
    cursor: pointer;
    border: 1px solid #05b570;
  }
  .change{
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .change .el-icon-circle-plus-outline{
    font-size: 17px;
  }
  .change>span{
    font-size: 16px;
  }
  .top>span{
    font-size: 16px;
    color: #333;
    font-family: "SourceHanSansCN-Normal"
  }
  .adr{
    overflow:hidden;

    text-overflow:ellipsis;

    display:-webkit-box;

    -webkit-box-orient:vertical;

    -webkit-line-clamp:2;
    font-size: 14px;
    color: #333;
    height: 38px;
    font-family: "SourceHanSansCN-Normal"
  }
  .ite .el-icon-edit-outline,
  .ite .icon-delete{
    font-size: 18px;
    margin-top: 20px;
  }
  .mt2{
    margin-top: 20px;
  }
  .mt1{
    margin-top: 15px;
  }
  .prompt{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.3);
    text-align: center;
    z-index: 999;
  }
  .prompt .word{
    width: 600px;
    height: 200px;
    padding: 30px;
    margin: 100px auto;
    box-sizing: border-box;
    background-color: #fff;
  }
  .prompt .cancel,
  .prompt .ensure{
    width: 100px;
    height: 40px;
    line-height: 40px;
    color: #000;
    cursor: pointer;
    border: 1px solid #ccc;
  }
  .prompt .ensure{
    background-color: #ddd;
  }
  .prompt .flex{
    width: 260px;
    margin: 80px auto;
    display: flex;
    justify-content: space-between;
  }
  /*--------------新增地址样式------------*/
  .new{

  }
  /*--------------支付方式样式------------*/
  .content .pay_way .pay{
    width: 226px;
    height: 44px;
    background-color: #fff;
    border-radius: 3px;
    border: 1px solid #05b570;
    font-size: 16px;
    font-family: "SourceHanSansCN-Normal"
  }
  /*--------------商品清单样式------------*/
  .content .goods .item{
    height: 131px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
  }
  .content .goods .item>img{
    width: 100px;
    height: 100px;
  }
  .content .goods .item>span{
    font-size: 16px;
    color: #191b1b;
    font-family: "SourceHanSansCN-Normal"
  }
  /*--------------去付款样式------------*/
  .content .buy{
    background-color: #fff;
    text-align: right;
  }
  .content .buy .text{
    margin-top: 118px;
    font-family: "SourceHanSansCN-Normal";
  }
  .content .buy .rmb{
    font-size: 23px;
    font-family: "SourceHanSansCN-Normal";
  }
  .content  .buy .number{
    font-size: 30px;
    font-family: "SourceHanSansCN-Normal";
  }
  .content .buy button{
    width: 196px;
    height: 55px;
    font-size: 16px;
    font-family: "SourceHanSansCN-Normal";
    line-height: 55px;
    margin-top: 26px;
    color: #FFFFFF;
    background-color: #05b570;
    border-radius: 2px;
    cursor: pointer;
  }
</style>
<style>
  .el-input__inner{
    width: 226px;
    height: 44px;
    font-size: 16px !important;
    font-family: "SourceHanSansCN-Normal";
    background-color: #fff;
    border: 1px solid #eee;
  }
  .el-select-dropdown__item.selected{
    border: none;
    color: #333;
    background-color: #e5e5e5;
  }
  .el-select .el-input__inner:focus,
  .el-select .el-input.is-focus .el-input__inner{
    border-color: #05b570;
  }
</style>



// WEBPACK FOOTER //
// src/components/shoppingCar/settlement.vue